import { http  } from './http_service';
import jwt from 'jsonwebtoken';
//import store from '../store'
export function register(user){
    return http().post('/auth/register',user);
}

export function login(user){
    return http().post('/auth/login',user)
    .then(response => {
        if(response.status === 200)
        {
            //setToken(response.data)
        }
        return response.data
    });
}

// function setToken(user){
//     //https://www.npmjs.com/package/jsonwebtoken
//     const token = jwt.sign({user:user},'lvsolutiontoken')
//     localStorage.setItem(
//         "lv_token",
//         //user.access_token
//         //JSON.stringify(user)
//         token
//     );
//     store.dispatch('authenticate', user.user);
// }

export function isLoggedIn(){
    const token = localStorage.getItem('lv_token');
    return token !=null;
}

export function logout(){
    http().get('/auth/logout');
    localStorage.removeItem('lv_token');
}

export function getAccessToken(){
    const token =  localStorage.getItem('lv_token');
    if(!token){
        return null;
    }
    const tokenData = jwt.decode(token);
    return tokenData.user.access_token;
}

export function getProfile(){
    return http().get('/auth/profile');
}

export function makeId(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
}

export function userIP(){
    return http().get('/auth/userIP');
}
